import { EmptyState } from '@eventbrite/eds-empty-state';
import { GhostGraphic } from '@eventbrite/eds-iconography';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React from 'react';
import './CategoryBrowseEmptyState.scss';

interface CategoryBrowseEmptyStateProps {
    description?: GenericLazyString;
}

export const CategoryBrowseEmptyState: React.FunctionComponent<
    CategoryBrowseEmptyStateProps
> = ({ description }) => {
    const defaultDescription: GenericLazyString = gettext(
        'Adjust your filters and try again',
    );
    return (
        <section className="category-browse__empty-state">
            <EmptyState
                graphicType={<GhostGraphic />}
                title={gettext("We couldn't find anything")}
                description={description || defaultDescription}
            />
        </section>
    );
};
